import { render, staticRenderFns } from "./SideEditorComponent.vue?vue&type=template&id=58ca3aa9&"
import script from "./SideEditorComponent.vue?vue&type=script&lang=js&"
export * from "./SideEditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideEditorComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports